export const CORNER_RADIUS_MIN = 0;
export const CORNER_RADIUS_MAX = 100;
